<template>
	<div v-if="tileLayer" class="weather-timestamp">
		⏱️ Dati meteo: {{ timestamp }}
	</div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount, watch, ref } from "vue";
import L from "leaflet";

const props = defineProps<{
	map: any; // Leaflet Map instance
	layer: string; // 'precipitation_new', 'clouds_new', etc.
	opacity?: number;
}>();

let tileLayer: any = null;
const timestamp = ref<string>("");

const formatTime = () => {
	const now = new Date();
	return now.toLocaleTimeString("it-IT", {
		hour: "2-digit",
		minute: "2-digit",
	});
};

const createTileUrl = (layer: string) => {
	return `/proxy/owm-tiles/${layer}/{z}/{x}/{y}.png`;
};

const updateLayer = () => {
	if (!props.map) return;

	// Remove existing
	if (tileLayer) {
		tileLayer.remove();
		tileLayer = null;
	}

	// Add new
	const url = createTileUrl(props.layer);
	console.log(
		`[OpenWeatherLayer] Adding layer: ${props.layer} to map`,
		props.map,
	);

	try {
		tileLayer = L.tileLayer(url, {
			maxZoom: 18,
			attribution:
				'&copy; <a href="https://openweathermap.org/">OpenWeatherMap</a>',
			opacity: props.opacity || 1.0,
			zIndex: 100, // Ensure it overlays base map but is below controls
		});

		tileLayer.on("tileerror", (e: any) => {
			console.warn(`[OpenWeatherLayer] Tile error for ${props.layer}:`, e);
		});

		tileLayer.addTo(props.map);
		timestamp.value = formatTime();
		console.log(`[OpenWeatherLayer] Layer added successfully`);
	} catch (e) {
		console.error(`[OpenWeatherLayer] Error adding layer:`, e);
	}
};

onMounted(() => {
	updateLayer();
});

onBeforeUnmount(() => {
	if (tileLayer) {
		tileLayer.remove();
		tileLayer = null;
	}
});

watch(
	() => props.layer,
	() => {
		updateLayer();
	},
);

watch(
	() => props.map,
	(newMap) => {
		if (newMap) updateLayer();
	},
);
</script>

<style scoped>
.weather-timestamp {
	position: fixed;
	bottom: 45px;
	right: 20px;
	background: rgba(0, 0, 0, 0.7);
	color: white;
	padding: 8px 12px;
	border-radius: 8px;
	font-size: 13px;
	font-weight: 500;
	z-index: 1001;
	pointer-events: none;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

@media (max-width: 768px) {
	.weather-timestamp {
		bottom: 60px;
	}
}
</style>
